export default __webpack_public_path__ + "static/media/profile_cover.5f45d58d.jpg";